import { cx } from '@mage-ui/styled-system/css';
import {
  button,
  gridCol,
  highlightCard,
  text,
  title,
} from '@mage-ui/styled-system/recipes';
import Link from 'next/link';
import { GridCol } from '../../layouts/grids/GridCol';
import { GridRow } from '../../layouts/grids/GridRow';

export const HighlightCard = ({ data, ...props }) => {
  const classes = highlightCard();
  const titleSize = data.description ? '4' : '3';
  return (
    <GridRow className={classes.root} {...props}>
      <GridCol
        className={cx(gridCol({ colSpanL: '10' }), classes.contentWrapper)}
      >
        <h2
          className={cx(
            title({ size: titleSize, weight: 'bold' }),
            classes.title,
          )}
        >
          {data.title}
        </h2>
        {data.description && (
          <div
            className={cx(
              text({ size: '1', weight: 'medium' }),
              classes.description,
            )}
            dangerouslySetInnerHTML={{ __html: data.description }}
          />
        )}
      </GridCol>
      {(data.cta1_slug || data.cta2_slug) && (
        <GridCol className={classes.ctaWrapper}>
          {data?.cta1_description && (
            <div
              className={cx(
                text({ size: '2', weight: 'semiBold' }),
                classes.ctaDescription,
              )}
              dangerouslySetInnerHTML={{ __html: data?.cta1_description || '' }}
            />
          )}
          {data.cta1_slug && (
            <Link href={data.cta1_slug} className={button()}>
              {data.cta1_text}
            </Link>
          )}
          {data?.cta2_description && (
            <div
              className={cx(
                text({ size: '2', weight: 'semiBold' }),
                classes.ctaDescription,
              )}
              dangerouslySetInnerHTML={{ __html: data?.cta2_description || '' }}
            />
          )}
          {data.cta2_slug && (
            <Link href={data.cta2_slug} className={button()}>
              {data.cta2_text}
            </Link>
          )}
        </GridCol>
      )}
    </GridRow>
  );
};
